import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Skills, AccountInfo, Href, Portfolio, Installment } from "../../../../Constants/Constants";
import { SimpleNavProps } from "../../../../Types/UiKitsType";

const ArrowTabsNav: React.FC<SimpleNavProps> = ({ basicTab, setBasicTab }) => {
  return (
    <Nav pills className="nav-primary mb-3" id="pills-bg-tab2">
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "1" ? "active" : ""}`} onClick={() => setBasicTab("1")}>{AccountInfo}</NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "2" ? "active" : ""}`} onClick={() => setBasicTab("2")}>{Portfolio}</NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "3" ? "active" : ""}`} onClick={() => setBasicTab("3")}>{Skills}</NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`tab-primary ${basicTab === "4" ? "active" : ""}`} onClick={() => setBasicTab("4")}>{Installment}</NavLink>
      </NavItem>
    </Nav>
  );
};
export default ArrowTabsNav;
